import Content from './content';
import heroBg from '../../../img/renaissance-new/HeroSection/Hero Grid.svg';
import heroBgMob from '../../../img/renaissance-new/HeroSection/Hero- BG Mob.svg';

const index = () => {
  return (
    <div
      className="relative overflow-hidden"
      style={{
        background:
          'linear-gradient(180deg, #181B43 -24.23%, #2A3076 23.49%, #3C48B9 56.2%, #9EA4DC 68.51%, #FFFFFF 80.81%)',
      }}
    >
      {/* Decorative grid-line texture, fading toward the edges */}
      <div
        className="pointer-events-none absolute inset-0 sm:hidden"
        style={{
          backgroundImage: `url("${heroBgMob}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.6,
          maskImage: 'linear-gradient(to bottom, black 0%, black 55%, transparent 90%)',
          WebkitMaskImage: 'linear-gradient(to bottom, black 0%, black 55%, transparent 90%)',
        }}
      />
      <div
        className="pointer-events-none absolute inset-0 hidden sm:block"
        style={{
          backgroundImage: `url("${heroBg}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.6,
          maskImage: 'linear-gradient(to bottom, black 0%, black 55%, transparent 90%)',
          WebkitMaskImage: 'linear-gradient(to bottom, black 0%, black 55%, transparent 90%)',
        }}
      />

      <div className="relative flex items-center justify-center pt-8 pb-12 sm:pt-10 sm:pb-[100px] sm:px-[64px] px-5">
        <Content />
      </div>
    </div>
  );
};

export default index;
